import { AxiosError } from 'axios';
import { PUT_GROUP_EXAM_REGISTRATION_REMOVE_REGISTRATION } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PutRemoveExamRegistration {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutRemoveExamRegistration = ({ onSuccess, onError }: Input) => {
  const putRemoveExamRegistration = async (payload: PutRemoveExamRegistration) => {
    const res = await axiosClient.put(
      PUT_GROUP_EXAM_REGISTRATION_REMOVE_REGISTRATION(payload.uuid)
    );
    return res.data;
  };

  return useCustomMutation(putRemoveExamRegistration, {
    onSuccess,
    onError,
  });
};
